import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { ContextsContextsService } from 'src/app/services/contexts-services/contexts-contexts-services/contexts-contexts.service';
import { DepartmentBasic } from 'src/app/models/helpbutton-models/helpbutton-department-basic.model';
import { DepartmentsHelpbuttonService } from 'src/app/services/helpbutton-services/departments-helpbutton-service/departments-helpbutton.service';

@Component({
  selector: 'app-helpbutton-departments-breadcrumb-filter-card',
  templateUrl: './helpbutton-departments-breadcrumb-filter-card.component.html',
  styleUrls: ['./helpbutton-departments-breadcrumb-filter-card.component.scss']
})
export class HelpbuttonDepartmentsBreadcrumbFilterCardComponent implements OnInit {

  @Input() departments;
  centers;
  centersForm = new FormGroup({});

  constructor(private userStorageService: UserStorageService,
    private departmentsHelpButtonService: DepartmentsHelpbuttonService) { }

  ngOnInit() {
    this.getCenters();
    if (this.userStorageService.getFilterDepartments()) {
      this.centersForm.patchValue(this.userStorageService.getFilterDepartments()['centersForm']);
    }
    this.filter();
  }

  public updateCheckbox(form, reset?) {
    this._toggleCheckboxes(form, reset);
  }

  private _toggleCheckboxes(form, reset) {
    if (reset && form.get('all').value) {
      Object.entries(form.controls).forEach(c => (c[0] !== 'all') ? (c[1] as FormControl).setValue(false) : null);
    } else if (Object.entries(form.controls).find(c => (c[0] !== 'all') && (c[1] as FormControl).value)) {
      form.get('all').setValue(false);
    } else if (!Object.entries(form.controls).find(c => (c[1] as FormControl).value)) {
      form.get('all').setValue(true);
    }
    this.userStorageService.setFilterDepartments({ centersForm: this.centersForm.getRawValue() });
    if (this.userStorageService.getFilterDepartments()['centersForm']['all']) {
      this.userStorageService.deleteFilterDepartments();
    }
    this.filter();
  }

  private getCenters() {
    const centers = new Array<string>();
    this.centersForm.addControl('all', new FormControl(true));
    this.departments.forEach((d: DepartmentBasic) => {
      if (centers.indexOf(d.CenterName) === -1) {
        centers.push(d.CenterName);
        this.centersForm.addControl(d.CenterName, new FormControl(false));
      }
    });
    this.centers = centers;
  }

  public filter() {
    const departments = {
      centersForm:
      {
        attribute: 'CenterName',
        values: []
      }
    };
    if (this.centersForm.get('all').value) {
      departments['centersForm'].values = Object.keys(this.centersForm.value).splice(1);
    } else {
      Object.entries(this.centersForm.value).forEach(c => { if (c[1]) { departments['centersForm'].values.push(c[0]); }});
    }
    this.departmentsHelpButtonService.filterDepartments(departments);
  }
}
